import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { SearchResults } from '@models/SearchResults'

import { queryKey as activiteitenQueryKey } from '../../../entity/activiteiten/hooks/useSearchActiviteitenForEntity'
import { queryKey as assignedBijlagenQueryKey } from '../../../entity/bijlagen/hooks/useAssignedBijlagenForEntity'
import { queryKey as bijlagenQueryKey } from '../../../entity/bijlagen/hooks/useBijlagenForEntity'
import { queryKey as linkedProjectsQueryKey } from '../../../entity/projecten/hooks/useLinkedProjectsForEntity'
import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey as projectenQueryKey } from '../../projecten/hooks/useProjectenSearch'
import { queryKey as projectQueryKey } from '../hooks/useProject'
import { saveEvent } from '../services/saveEvent'
import type { Project } from '../types/Project'

import { queryKey as projectLogQueryKey } from './useProjectLog'

export { useSaveEvent }

const useSaveEvent = () => {
  const { successAlert, errorAlert } = useAlerts()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: saveEvent,
    onSuccess: (data, variables) => {
      queryClient.setQueryData([projectQueryKey, variables.id], data)
      queryClient.setQueriesData({ queryKey: [projectenQueryKey] }, (old) => ({
        ...(old as SearchResults<Project>),
        items: (old as SearchResults<Project>).items.map((item) => {
          if (item.aanvraagID === data.aanvraagID) {
            return data
          }
          return item
        }),
      }))
      queryClient.invalidateQueries({ queryKey: [projectLogQueryKey] })
      queryClient.invalidateQueries({ queryKey: [linkedProjectsQueryKey] })
      queryClient.invalidateQueries({ queryKey: [activiteitenQueryKey] })
      queryClient.invalidateQueries({ queryKey: [bijlagenQueryKey] })
      queryClient.invalidateQueries({ queryKey: [assignedBijlagenQueryKey] })

      successAlert('Wijziging succesvol opgeslagen')
    },
    onError: (error: any) => {
      errorAlert('Fout bij opslaan wijziging', error)
    },
  })
}
